import type { CSSProperties } from 'react';
import { LOADER_TEMPO } from '../../../src/constants/danceLoaders';
import './DanceLoaders.css';

export function EqualizerLoader() {
  return (
    <div
      className="dance-equalizer"
      role="status"
      aria-label="Loading…"
      style={{ '--dance-tempo': LOADER_TEMPO } as CSSProperties}
    >
      <div className="dance-equalizer-bar" />
      <div className="dance-equalizer-bar" />
      <div className="dance-equalizer-bar" />
      <div className="dance-equalizer-bar" />
      <div className="dance-equalizer-bar" />
    </div>
  );
}
